import { render, staticRenderFns } from "./questionnaire-selection.vue?vue&type=template&id=e5321b22&lang=pug&"
import script from "./questionnaire-selection.vue?vue&type=script&lang=js&"
export * from "./questionnaire-selection.vue?vue&type=script&lang=js&"
import style0 from "./questionnaire-selection.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports